import { ol_Feature, ol_Map, ol_Overlay } from "@omnia/exports/openlayers";
import { IAnalysisLayerData } from "./analysis-layer";

export class HighlightOverlay {

    private overlay: ol_Overlay;

    constructor(private feature: ol_Feature, private _olmap: ol_Map) {

        this.overlay = this.createOverlay();

        this.updateOverlay(this.feature, this.overlay);
    }


    dispose() {

        if (this.overlay) {
            this._olmap.removeOverlay(this.overlay);
            this.overlay = null;
        }

    }


    private createOverlay() {

        let element = <HTMLElement>document.createElement("div");
        element.className = "highlight";

        let overlay = new ol_Overlay({
            element: element,
            stopEvent: false,
            offset: [0, 0],
            positioning: length ? "bottom-center" : "center-center",
        });

        this._olmap.addOverlay(overlay);

        return overlay;

    }

    private updateOverlay(feature: ol_Feature, overlay: ol_Overlay) {

        let element = <HTMLElement>overlay.getElement();
        let coord: number[];
        let text: string;
        let data: IAnalysisLayerData = feature.get("data").data;

        let geom: any = feature.getGeometry();

        coord = geom.getInteriorPoint().getCoordinates();

        if (data) {

            let fieldDescription = data.field.getDescription(true) + (data.zone ? " - Zone " + data.zone.Number : "");

            text = fieldDescription;

            overlay.setPosition(coord);
            element.innerHTML = text;

        } else {

            overlay.setPosition(undefined);

        }


    }

}

